import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import Nav from "./Nav";
import Footer from "./Footer";

/**
 * Nav theme. "dark" = dark text on a solid paper bar (default).
 * "light" = light text over a transparent bar, for pages that open with a
 * full-bleed dark hero. Call `useNavTheme("light")` inside such a hero.
 */
const NavThemeContext = createContext({ theme: "dark", setTheme: () => {} });

export function useNavTheme(theme) {
  const { setTheme } = useContext(NavThemeContext);
  useEffect(() => {
    setTheme(theme);
    return () => setTheme("dark");
  }, [theme, setTheme]);
}

export default function Layout({ children, location }) {
  const [theme, setThemeState] = useState("dark");
  const setTheme = useCallback((t) => setThemeState(t), []);
  const value = useMemo(() => ({ theme, setTheme }), [theme, setTheme]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (location.hash) return; // let the browser jump to the anchor
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  return (
    <NavThemeContext.Provider value={value}>
      <a href="#main" className="skip-link">Skip to content</a>
      <Nav path={location.pathname} theme={theme} />
      <main id="main">{children}</main>
      <Footer />
    </NavThemeContext.Provider>
  );
}
